import * as React from 'react';
import { withStyles } from '@material-ui/core';
import { Page as PDFPage } from 'react-pdf/dist/umd/entry.webpack';
import { compose } from '../../../utility';
import type { AdaptedPage } from '../flowTypes';
import styles from './basePage.styles';
import PageHeader, { PAGE_HEADER_HEIGHT } from '../pageHeader';

type Props = {
  page: AdaptedPage,
  classes: Object,
  children: React.Node,
  zoom: number,
  pdfPages: Object,
};

export class BasePageC extends React.PureComponent<Props> {
  render() {
    const { page, classes, children, zoom, pdfPages } = this.props;

    const pageWidth = page.width || 0;
    const pageHeight = page.height || 0;

    return (
      <div
        className={classes.page}
        style={{
          width: pageWidth * zoom,
          height:
            pageHeight * zoom +
            (page.pageNumber === 1 ? PAGE_HEADER_HEIGHT : 0),
        }}
      >
        {page.pageNumber === 1 && (
          <PageHeader documentName={page.documentName} />
        )}
        {pdfPages && pdfPages[page.documentId] && page.pageNumber && (
          <PDFPage
            className={classes.pdfPageRendered}
            loading=""
            pdf={pdfPages[page.documentId].pdf}
            pageNumber={page.pageNumber}
            width={pageWidth * zoom}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        )}
        <div
          className={classes.content}
          style={{
            height:
              page.pageNumber === 1
                ? `calc(100% - ${PAGE_HEADER_HEIGHT}px)`
                : '100%',
            top: page.pageNumber === 1 ? PAGE_HEADER_HEIGHT : 0,
          }}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default compose(withStyles(styles))(BasePageC);
